/*
    Copyright (C) 2023 - Wheel and Brake - Southwest Airlines
*/
import React from "react";

function NoMatch() {
    return (
        <div style={{display: "flex", justifyContent: "center", verticalAlign: "center", alignItems: "center", height: "20vh"}}>
            <h1>
                NO MATCH
            </h1>
        </div>
    );
}

export default NoMatch;